// extracted by mini-css-extract-plugin
export default {"grid":"CatalogGrid_grid__jNG95"};